import * as api from './serverApi';

export type UserDataResponse = {
  country: string;
  isNewUser: boolean;
  name: string;
  smallProfileImageUrl: string | null;
  largeProfileImageUrl: string | null;
};

export default process.env.NEXT_PUBLIC_USE_MOCK_API
  ? require('./mockApi')
  : api;
